import { ApiConfig, envConfig, Locale, Scope } from '@headless-workspace/config';
import { Repository, Result, ResultEmpty, ResultFailure, ResultSuccess } from '@headless-workspace/core-domain';
import { initRequestStrategy } from '@headless-workspace/data';
import { StringHelpers } from '@headless-workspace/utils';
import { HealthStatusValue } from './HealthStatusValue';
import { SanityCheckScope } from './SanityCheckScope';

type SanityCheckRequestOptions = {
    secret: string;
};

const ROUTE_PATH_SEPARATOR = '/';

const LOCAL_ENV = 'local';
const LOCAL_HOST_URL = 'http://localhost:3000';

export interface SanityCheckRepositorySpec {
    checkHealth(scope: Scope, locale: Locale, options: SanityCheckRequestOptions): Promise<Result<HealthStatusValue>>;
}

export class SanityCheckRepository extends Repository implements SanityCheckRepositorySpec {
    path = ApiConfig.headless.paths.sanityCheck;

    constructor(hostUrl: string, requestStrategy = initRequestStrategy()) {
        super(
            requestStrategy.authStrategy,
            requestStrategy.refreshTokenStrategy,
            requestStrategy.queryParamStrategy,
            StringHelpers.addSuffix(
                envConfig.runtimeEnvironment === LOCAL_ENV ? LOCAL_HOST_URL : `${hostUrl}`,
                ROUTE_PATH_SEPARATOR,
                true,
            ),
        );
    }

    async checkHealth(
        scope: SanityCheckScope,
        locale: Locale,
        options: SanityCheckRequestOptions,
    ): Promise<Result<HealthStatusValue>> {
        const url = this.path;
        try {
            const response = await this.datasource.getResource<HealthStatusValue>(url, {
                scope,
                locale,
                ...options,
            });

            return response ? ResultSuccess(response) : ResultEmpty();
        } catch (error) {
            const apiError = this.handleApiError(error);
            return ResultFailure(apiError.code, apiError.message, {
                locale,
                scope,
                url,
            });
        }
    }
}
